/**
 *  <Desription of Service here>
 *
 * @export
 * @class ScreenManager
 */
export class ScreenManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$animate', 'TransitionManager', 'ModalManager', '$timeout', 'ProgressManager', 'PixiManager', '$rootScope', 'AudioManager', 'TrackingManager', 'HeroManager'];
  public isAnimating: boolean
  public screens: any
  public genderScreenOptions: any
  public poseScreenOptions: any
  public creatorScreenOptions: any
  public comicScreenOptions: any
  public downloadScreenOptions: any
  public sharedImage: any
  public autoTimer
  public displayBackgrounds: boolean = true
  public navDisabled: boolean = false

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public $animate: any, public TransitionManager: any, public ModalManager: any, public $timeout: ng.ITimeoutService, public ProgressManager: any, public PixiManager: any, public $rootScope: any, public AudioManager: any, public TrackingManager: any, public HeroManager: any) {
    this.$log = $log.getInstance('Screen', false);
    this.$log.debug('constructor');
    this.isAnimating = false;

    this.$rootScope.$on('progress:screen', (event, data) => {
      if (data.screenIndex >= 4) { data.screenIndex = 3}
      this.setActiveScreen(data.screenIndex, false)
    })
  }

  public switchCarousel() {
    if (this.displayBackgrounds) {
      this.displayBackgrounds = false;
    } else {
      this.displayBackgrounds = true;
    }
  }

  public enableNav() {
    this.$timeout(() => {
      this.navDisabled = false
      let doneButton = document.querySelectorAll('.done-button')[0]
      let undoButton = document.querySelectorAll('.undo-button')[0]
      if(doneButton){
        this.$animate.removeClass(doneButton, 'done-hovered')
      }
      if(undoButton){
        this.$animate.removeClass(undoButton, 'undo-hovered')
      }
    }, 1200);
  }

  public init(config): void {
    this.$log.debug('init')
    this.screens = config.screens;
    this.setActiveScreen(0, false)
    let imageURL = this.getURLParam( 'imageurl' );
    if (imageURL){
      this.setActiveScreen(5, false)
      this.$rootScope.$broadcast('shareScreenIsActive', { disableNav: true });
    }
  }

  public setActiveScreen(index: number, storeProgress: boolean = true): void {
    this.$log.debug('setActiveScreen', index);
    this.screens.forEach(this.makeScreenInactive);
    this.screens[index].active = true;
    if (storeProgress) {
      this.ProgressManager.setScreenIndex(index);
    }
    if (this.screens[index].title === 'Gender Screen'){
      this.$rootScope.$broadcast('genderScreenIsActive', { options: this.genderScreenOptions });
    }
    if (this.screens[index].title === 'Pose Screen'){
      this.$rootScope.$broadcast('poseScreenIsActive', { options: this.poseScreenOptions });
    }
    if (this.screens[index].title === 'Creator Screen'){
      this.$rootScope.$broadcast('creatorScreenIsActive', { options: this.creatorScreenOptions });
    }
    if (this.screens[index].title === 'Comic Screen'){
      this.$rootScope.$broadcast('comicScreenIsActive', { options: this.comicScreenOptions });
    }
    if (this.screens[index].title === 'Download Screen'){
      this.$rootScope.$broadcast('downloadScreenIsActive', { options: this.downloadScreenOptions });
    }
  }

  public getActiveScreen(screens): any {
    return this.screens.filter(this.findActiveScreen)[0];
  }

  public findActiveScreen(element, index, array) {
    return element.active === true;
  }

  public makeScreenInactive(element, index, array) {
    element.active = false
  }

  public isFirstScreen(screen): boolean {
    return this.findScreenIndex(screen) === 0
  }

  public isLastScreen(screen): boolean {
    return this.findScreenIndex(screen) === this.screens.length;
  }

  public findScreenIndex(screen) {
    return this.screens.indexOf(screen);
  }

  public performNavigation(command, currentScreen): void {
    this.$log.debug('performNavigation', currentScreen)
    switch (command.toLowerCase()) {
      case 'next':
        if (currentScreen.title === 'Comic Screen'){
          if (this.displayBackgrounds) {
            this.switchCarousel();
            this.enableNav()
          } else {
            this.$animate.addClass(document.querySelector('.screen-container__loader'), 'visible')
            this.$animate.addClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
            this.nextScreen(currentScreen);
            this.enableNav()
          }
          this.AudioManager.playFx('screenTransition');
        }else if (currentScreen.title === 'Creator Screen'){
            this.$animate.addClass(document.querySelector('.screen-container__loader'), 'visible')
            this.$animate.addClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
            this.$timeout(() => {
              this.ProgressManager.setHero(document.querySelector(this.HeroManager.svgElement).innerHTML)
              this.HeroManager.setHeroImageData()
              this.PixiManager.addHeroToCover()
              this.HeroManager.zoomOut()
              this.enableNav()
              this.nextScreen(currentScreen);
              this.AudioManager.playFx('screenTransition');
            }, 600);
        } else if(currentScreen.title === 'Pose Screen'){
          this.TrackingManager.trackPose(this.HeroManager.selectedGender, this.HeroManager.selectedPose)
          this.enableNav()
          this.nextScreen(currentScreen);
          this.AudioManager.playFx('screenTransition');
        } else{
          this.nextScreen(currentScreen);
          this.enableNav()
          this.AudioManager.playFx('screenTransition');
        }
        break;
      case 'previous':
        if (currentScreen.title !== 'Gender Screen'){
          if (currentScreen.title === 'Comic Screen'){
            if (!this.displayBackgrounds) {
              this.switchCarousel();
              this.enableNav()
            } else {
              this.previousScreen(currentScreen);
              this.enableNav()
            }
            this.AudioManager.playFx('screenTransition');
          }else if (currentScreen.title === 'Creator Screen'){
            this.ProgressManager.setHero(document.querySelector(this.HeroManager.svgElement).innerHTML)
            // this.HeroManager.setHeroImageData()
            this.HeroManager.zoomOut()
            this.enableNav()
            this.previousScreen(currentScreen);
            this.AudioManager.playFx('screenTransition');
          }else{
            this.previousScreen(currentScreen);
            this.enableNav()
            this.AudioManager.playFx('screenTransition');
          }
        }
        break;
      case 'jumptostart': {
        this.jumpToStart(currentScreen)
        break;
      }
      default:
        break;
    }
  }

  public jumpToStart(currentScreen) {
    let _self = this;
    this.$log.debug('jumpToStart', currentScreen);
    this.$timeout.cancel(this.autoTimer)

      // if (currentScreen.nextCover) {
      this.TransitionManager.close(currentScreen).then(() => {
        this.$timeout(() => {
        // if ('false' === currentScreen.isLast) {
        _self.$animate.addClass(currentScreen.$element, currentScreen.exitNextTransition).then(() => {
          _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitNextTransition)
          _self.TransitionManager.open(currentScreen);
        })

        this.switchToScreen({
          'command': 'next',
          'currentScreen': currentScreen,
          'futureScreen': this.screens[1],
          'futureScreenElement': currentScreen.$element.parent().parent().parent().children(0).children(0).children(0).children(0)
        })
      // }
      }, 200)
    });

    // } else {
    // if ('false' === currentScreen.isLast) {
    // currentScreen.$ctrl.onExitStart()
    // this.$animate.addClass(currentScreen.$element, currentScreen.exitNextTransition).then(() => {
    //   _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitNextTransition)
    //   currentScreen.$ctrl.onExitComplete()
    // })

    // this.switchToScreen({
    //   'command': 'next',
    //   'currentScreen': currentScreen,
    //   'futureScreen': this.screens[0],
    //   'futureScreenElement': currentScreen.$element.parent().parent().parent().children(0).children(0).children(0).children(0)
    // })
    // }
    // }
  }

  public nextScreen(currentScreen) {
    let _self = this;
    this.$log.debug('nextScreen', currentScreen);
    this.$timeout.cancel(this.autoTimer)

    if (currentScreen.nextCover) {
      // this.TransitionManager.close(currentScreen).then(() => {
      //   if ('false' === currentScreen.isLast) {
      //     _self.$animate.addClass(currentScreen.$element, currentScreen.exitNextTransition).then(() => {
      //       _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitNextTransition)
      //       _self.TransitionManager.open(currentScreen);
      //     })

      //     _self.switchToScreen({
      //       'command': currentScreen.command,
      //       'futureScreenElement': currentScreen.$element.parent().parent().parent().next().children(0).children(0).children(0)
      //     });
      //   }
      // });
    } else {
      if ('false' === currentScreen.isLast) {
        currentScreen.$ctrl.onExitStart()
        this.$animate.addClass(currentScreen.$element, currentScreen.exitNextTransition).then(() => {
          _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitNextTransition)
          currentScreen.$ctrl.onExitComplete()
        })

        this.switchToScreen({
          'command': 'next',
          'currentScreen': currentScreen,
          'futureScreen': this.screens[this.findScreenIndex(currentScreen) + 1],
          'futureScreenElement': currentScreen.$element.parent().parent().parent().next().children(0).children(0).children(0)
        })
      }
    }
  }

  public previousScreen(currentScreen) {
    let _self = this;
    this.$log.debug('previousScreen', currentScreen);
    this.$timeout.cancel(this.autoTimer)

    if (currentScreen.previousCover) {
      // this.TransitionManager.close(currentScreen).then(() => {
      //   if ('false' === currentScreen.isFirst) {
      //     this.$animate.addClass(currentScreen.$element, currentScreen.exitPreviousTransition).then(() => {
      //       _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitPreviousTransition)
      //       _self.TransitionManager.open(currentScreen);
      //     })

      //     this.switchToScreen({
      //       'screen': currentScreen,
      //       'futureScreenElement': currentScreen.$element.parent().parent().parent()[0].previousElementSibling.children[0].children[0].children[0]
      //     })
      //   }
      // })
    } else {
      if ('false' === currentScreen.isFirst) {
        currentScreen.$ctrl.onExitStart()
        this.$animate.addClass(currentScreen.$element, currentScreen.exitPreviousTransition).then(() => {
          _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitPreviousTransition)
          currentScreen.$ctrl.onExitComplete()
        })

        this.switchToScreen({
          'command': 'previous',
          'currentScreen': currentScreen,
          'futureScreen': this.screens[this.findScreenIndex(currentScreen) - 1],
          'futureScreenElement': currentScreen.$element.parent().parent().parent()[0].previousElementSibling.children[0].children[0].children[0]
        });
      }
    }

  }

  public switchToScreen(options: any): void {
    let _self = this;
    this.$log.debug('switchToScreen', options)
    if (this.isAnimating) {
      return
    }

    this.isAnimating = true;

    switch (options.command.toLowerCase()) {
      case 'next':
        options.futureScreen.$ctrl.onEnterStart()
        this.$animate.addClass(options.futureScreenElement, 'active ' + options.futureScreen.enterNextTransition).then(() => {
          _self.$animate.removeClass(options.futureScreenElement, options.futureScreen.enterNextTransition)
          _self.isAnimating = false;
          _self.setActiveScreen(_self.findScreenIndex(options.futureScreen))
          options.futureScreen.$ctrl.onEnterComplete()
          _self.processDelayTimer(options)
        })
        break;
      case 'previous':
        options.futureScreen.$ctrl.onEnterStart()
        this.$animate.addClass(options.futureScreenElement, 'active ' + options.futureScreen.enterPreviousTransition).then(() => {
          this.$animate.removeClass(options.futureScreenElement, options.futureScreen.enterPreviousTransition)
          this.isAnimating = false;
          _self.setActiveScreen(_self.findScreenIndex(options.futureScreen))
          options.futureScreen.$ctrl.onEnterComplete()
          _self.processDelayTimer(options)
        })
        break;
      default:
        break;
    }
  }

  public openHelp() {
    this.$log.debug('openHelp', this.getActiveScreen(this.screens))
    this.ModalManager.activate(this.getActiveScreen(this.screens))
  }

  public openModal(options) {
    this.$log.debug('openModal', this.getActiveScreen(this.screens))
    if(options !== undefined){
      this.ModalManager.activate(options)
    }else{
      this.ModalManager.activate(this.getActiveScreen(this.screens))
    }
    //this.ModalManager.activate(this.getActiveScreen(this.screens))
  }

  public processDelayTimer(options) {
    this.$log.debug('processDelayTimer', options)

    if (options.futureScreen.displayDurationinMS !== undefined) {
      switch (options.command.toLowerCase()) {
        case 'next':
          this.autoTimer = this.$timeout(() => { options.futureScreen.$ctrl.onNext() }, options.futureScreen.displayDurationinMS)
          break;
        case 'previous':
          this.autoTimer = this.$timeout(() => { options.futureScreen.$ctrl.onPrevious() }, options.futureScreen.displayDurationinMS)
          break;
        default:
          break;
      }
    }
  }

  public getURLParam( name ){
     name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
     let regexS = "[\\?&]"+name+"=([^&#]*)";
     let regex = new RegExp( regexS );
     let results = regex.exec( window.location.href );
     if( results == null ){
       return "";
     }else{
      return results[1];
     }
  }

}



/** WEBPACK FOOTER **
 ** ./src/common/services/screen-manager/screen-manager.ts
 **/